var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WISYWIG",
    transform: "translate(-910.000000, -472.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(420.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(490.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Align-Justified-Copy",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    x: 0,
    y: 0,
    width: 21.3559322,
    height: 21.3559322
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7966102,4 L19.7966102,5.77966102 L2,5.77966102 L2,4 L19.7966102,4 Z M19.7966102,9.33898305 L19.7966102,11.1186441 L2,11.1186441 L2,9.33898305 L19.7966102,9.33898305 Z M19.7966102,14.6779661 L19.7966102,16.4576271 L2,16.4576271 L2,14.6779661 L19.7966102,14.6779661 Z",
    id: "Combined-Shape",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 1.500000)",
    fill: "#838588",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.5
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: 3
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15.5
  }, "3"))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.960d57d81f1d3fb1702c64d7ef3cb083.svg";
export { ForwardRef as ReactComponent };